/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import React, {PropsWithChildren} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {translate} from '@ion/core/src/locale/locale';
import {dlsAlt, dlsColor} from '@ion/dls/src/theme/theme';

export interface SplitInformationViewProps {
  text?: string;
}
const DISTANCE_FROM_TOP = 200;
const DISTANCE_FROM_BOTTOM = 70;

const useStyles = makeStyles(() => ({
  flexContainer : {
    display   : 'flex',
    gap       : '15px',
    height    : `calc(100vh - ${DISTANCE_FROM_BOTTOM + DISTANCE_FROM_TOP}px)`,
    marginTop : '20px'
  },
  side : {
    backgroundColor : dlsColor('white'),
    overflow        : 'scroll',
    padding         : '0 15px'
  },
  left : {
    flex : 1
  },
  right : {
    flex : 2
  },
  text : {
    whiteSpace : 'pre-wrap'
  }
}));

/**
 * Displays a split-view information viewer where any children are displayed in the left side
 * and the given `text` is displayed on the right side.
 */
export const SplitInformationView = ({
  children,
  text = translate('admin-devices:view.manufacturing.noDataAvailable')
}: PropsWithChildren<SplitInformationViewProps>) => {
  const classes = useStyles();
  return (
    <div className={classes.flexContainer}>
      <div className={classnames(classes.side, classes.left)}>
        {children}
      </div>
      <div className={classnames(classes.side, classes.right)}>
        <p className={classes.text}>
          {text || ''}
        </p>
      </div>
    </div>
  );
};

export default SplitInformationView;
